import axios from "axios";
import {
    URLAPI,
    GROUPS_SECTION_PATH,
    GROUP_ITEM_PATH,
    GROUP_CREATE_PATH,
    GROUP_UPDATE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_group: {
        data: [],
        status: 0,
        message: {},
    },
    _create_group: {
        data: {},
        status: 0,
        message: {},
    },
    _update_group: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_GROUPS = "GET_ALL_GROUPS";
export const CREATE_GROUP = "CREATE_GROUP";
export const UPDATE_GROUP = "UPDATE_GROUP";


export const group_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_GROUPS:
            return {
                ...state,
                _get_all_group: action.payload,
            };
        case CREATE_GROUP:
            return {
                ...state,
                _create_group: action.payload,
            };
        case UPDATE_GROUP:
            return {
                ...state,
                _update_group: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_group = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${GROUPS_SECTION_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_GROUPS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_GROUPS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_GROUPS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los registros",
                },
            });
        }
    }
}


export const create_group = (token, data) => async (dispatch) => {
    try {

        const response = await axios.post(`${URLAPI}${GROUP_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: CREATE_GROUP,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_GROUP,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_GROUP,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear el registro",
                },
            });
        }
    }
}


export const update_group = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${GROUP_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_GROUP,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_GROUP,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_GROUP,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const searchItemGroup = async (token, id) => {
    return await axios.get(`${URLAPI}${GROUP_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
}

export const clear_group = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}